export default "__VITE_ASSET__xfT75qks__"